import React from 'react';
import { toI18nMessageId, useI18n, useStaticIntl, } from '@tribeplatform/react-components/i18n';
import { useRouter } from '@tribeplatform/react-sdk';
import { SystemSpaceSlug, useAuthMember, useSpaceUtil, } from '@tribeplatform/react-sdk/hooks';
import { NavVertical } from '@tribeplatform/react-ui-kit/Sidebar';
import { mainMenuActiveIcons, mainMenuIcons } from './constants.js';
import { MainMenuAction } from './types.js';
import { getDeprecatedItemsCleaner } from './utils.js';
export const MainMenuBlock = ({ items: _items }) => {
    const { getMessageByDynamicId } = useI18n();
    const { Link, location } = useRouter();
    const { data: authMember } = useAuthMember();
    const { generateProfilePath, matchPath, hasViewPermission } = useSpaceUtil();
    const deprecatedItemsCleaner = useStaticIntl(getDeprecatedItemsCleaner);
    const items = deprecatedItemsCleaner(_items);
    const pathMapping = {
        [SystemSpaceSlug.HOME]: '/',
        [SystemSpaceSlug.MEMBERS]: '/members',
        [SystemSpaceSlug.SPACES]: '/spaces',
        [SystemSpaceSlug.NOTIFICATIONS]: '/notifications',
        [SystemSpaceSlug.SEARCH]: '/search',
    };
    return (React.createElement(NavVertical, { className: "block-main-menu" },
        React.createElement(NavVertical.Group, null, items
            .map(item => {
            var _a;
            if (!item.enabled) {
                return null;
            }
            const IconComponent = mainMenuIcons[item.icon];
            const ActiveIconComponent = mainMenuActiveIcons[item.icon];
            let matched;
            let isActive;
            const spacePath = pathMapping[item === null || item === void 0 ? void 0 : item.spaceSlug] || '/';
            const labelText = getMessageByDynamicId(toI18nMessageId('Navigation', item.label), item.label);
            switch (item.action) {
                case MainMenuAction.OPEN_LINK:
                    return (React.createElement(NavVertical.Item, { key: item.label, as: Link, variant: "inherit", href: item.link, active: false, leadingIcon: React.createElement(IconComponent, null), target: "_blank" }, labelText));
                case MainMenuAction.OPEN_PROFILE:
                    if (!hasViewPermission(SystemSpaceSlug.MEMBER)) {
                        return null;
                    }
                    matched = matchPath(SystemSpaceSlug.MEMBER, location.pathname);
                    isActive = matched && ((_a = matched === null || matched === void 0 ? void 0 : matched.params) === null || _a === void 0 ? void 0 : _a.id) === (authMember === null || authMember === void 0 ? void 0 : authMember.id);
                    return (React.createElement(NavVertical.Item, { key: item.label, as: Link, variant: "inherit", href: generateProfilePath(), active: isActive, leadingIcon: isActive ? React.createElement(ActiveIconComponent, null) : React.createElement(IconComponent, null) }, labelText));
                case MainMenuAction.OPEN_SPACE:
                    if (!spacePath) {
                        return null;
                    }
                    matched = spacePath === location.pathname;
                    return (React.createElement(NavVertical.Item, { key: item.label, as: Link, variant: "inherit", href: spacePath, active: !!matched, leadingIcon: matched ? React.createElement(ActiveIconComponent, null) : React.createElement(IconComponent, null) }, labelText));
                default:
                    return null;
            }
        })
            .filter(item => item))));
};
//# sourceMappingURL=Block.js.map